export default "__VITE_ASSET__D703odvL__"